module.exports = __webpack_public_path__ + "media/images/cardboard-img-09-afbfd8b1d8a309d3deb0e4e6151298c4.png";